import React, { useState } from 'react'
import PropType from 'prop-types'
import config from 'config'

import RadioGroup from '@cred/react-basic-form-fields/RadioGroup'

import CtaButton from 'components/cta-button'
import { fireGtmEvent } from 'utils/gtm'
import PoweredBy from 'components/powered-by'

import styles from './styles.module.scss'

const radioOptions = [
  { value: 'refinance-student-loans', label: 'Refinance my student loans' },
  { value: 'student-loans', label: 'Get a new student loan' },
]

const StudentLoanCombinedForm = (props) => {
  const { ctaText, queryString, widgetContext, metaQuery } = props
  const [href, setHref] = useState('')
  const [loanOption, setLoanOption] = useState('')
  const [error, setError] = useState(null)

  const onChange = (value) => {
    setError(null)
    setLoanOption(value)
    setHref(`${config.credibleRoot}/${value}?${queryString}${metaQuery}`)

    fireGtmEvent('fieldChange', { ...widgetContext, loanOption: value })
  }

  const onClick = () => {
    if (!loanOption) {
      setError('Select an option above.')
    }
    fireGtmEvent('ctaClick', { ...widgetContext, loanOption })
  }

  return (
    <>
      <div className={`studnet-loan-combined ${styles.selection}`}>
        <p className={`${styles.title} mb-16`}>I'm looking to...</p>
        <RadioGroup
          id="loanOption"
          name="loanOption"
          className="mb-16"
          inputProps={{
            onChange,
          }}
        >
          {radioOptions.map(({ label, value }) => (
            <option label={label} value={value} key={`radio-${value}`} />
          ))}
        </RadioGroup>
        {error && <p className={`${styles.error} mb-8`}>{error}</p>}
      </div>
      <section className={styles.submit}>
        <CtaButton
          data-testid="cta-button"
          href={href}
          onClick={onClick}
          target="_blank"
          fullWidth
          analytics={{
            data: { text: ctaText, activated: !!loanOption },
          }}
        >
          {ctaText}
        </CtaButton>
        <PoweredBy className="mt-8" />
      </section>
    </>
  )
}

StudentLoanCombinedForm.propTypes = {
  widgetContext: PropType.object.isRequired,
  ctaText: PropType.string.isRequired,
  queryString: PropType.string.isRequired,
  metaQuery: PropType.string,
}

export { StudentLoanCombinedForm }

export default StudentLoanCombinedForm
